import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { default as ReactSelect } from 'react-select';
import { components, NoticeProps } from 'react-select';

const Select = props => {
    const valueRef = useRef(props.value);
    valueRef.current = props.value;
    const selectAllOption = {
        label: 'Select all',
        value: '*',
    };

    const isSelectAllSelected = () => valueRef?.current?.length === props.options.length;

    // const isOptionSelected = option => {
    //     try {
    //         if (valueRef?.current) {
    //             valueRef.current.some(({ value }) => value === option.value) || isSelectAllSelected();
    //         }
    //     } catch (error) {

    //     }
    // }

    const isOptionSelected = option =>
        valueRef?.current?.some(({ value }) => value === option.value) || isSelectAllSelected();

    const getOptions = () => {
        try {
            const removeSelected = props.value ? props.value.some(item => item.isFixed === true) : false;
            return removeSelected ? [...props.options] : [selectAllOption, ...props.options];
        } catch (error) { }
    };

    const getValue = () => {
        try {
            const allSelected = props.value ? props.value.every(item => item.isFixed === true) : false;
            // console.log('isSelectAllSelected', isSelectAllSelected(), valueRef?.current, props.options)
            const isFixedLength = (valueRef?.current || []).filter(i => i.isFixed);
            return isSelectAllSelected() && props.options.length > 0 && isFixedLength?.length == 0
                ? [{ ...selectAllOption, ...(allSelected ? { isFixed: true } : {}) }]
                : props.value;
        } catch (error) { }
    };

    const onChange = (newValue, actionMeta) => {
        try {
            const { action, option, removedValue } = actionMeta;

            if (action === 'select-option' && option.value === selectAllOption.value) {
                props.onChange(props.options, actionMeta);
            } else if (
                (action === 'deselect-option' && option.value === selectAllOption.value) ||
                (action === 'remove-value' && removedValue.value === selectAllOption.value)
            ) {
                props.onChange([], actionMeta);
            } else if (actionMeta.action === 'deselect-option' && isSelectAllSelected()) {
                props.onChange(
                    props.options.filter(({ value }) => value !== option.value),
                    actionMeta,
                );
            } else {
                props.onChange(newValue || [], actionMeta);
            }
        } catch (error) { }
    };

    const NoOptionsMessage = (props: NoticeProps) => {
        // props['children'] = 'testtttt';

        return <components.NoOptionsMessage {...props} />;
    };

    if (props.allowSelectAll) {
        return (
            <ReactSelect
                {...props}
                isOptionSelected={isOptionSelected}
                options={getOptions()}
                value={getValue()}
                onChange={onChange}
                // hideSelectedOptions={false}
                // closeMenuOnSelect={false}
                components={{ NoOptionsMessage }}
            // styles={{ noOptionsMessage: base => ({ ...base, ...msgStyles }) }}
            />

            // <ReactSelect
            //     {...props}
            //     options={[props.allOption, ...props.options]}
            //     onChange={(selected, event) => {
            //         if (selected !== null && selected.length > 0) {
            //             if (selected[selected.length - 1].value === props.allOption.value) {
            //                 return props.onChange([props.allOption, ...props.options]);
            //             }
            //             let result = [];
            //             if (selected.length === props.options.length) {
            //                 if (selected.includes(props.allOption)) {
            //                     result = selected.filter(
            //                         option => option.value !== props.allOption.value
            //                     );
            //                 } else if (event.action === "select-option") {
            //                     result = [props.allOption, ...props.options];
            //                 }
            //                 return props.onChange(result);
            //             }
            //         }

            //         return props.onChange(selected);
            //     }}
            // />
        );
    }

    return <ReactSelect {...props} />;
};

Select.propTypes = {
    options: PropTypes.array,
    value: PropTypes.any,
    onChange: PropTypes.func,
    allowSelectAll: PropTypes.bool,
    allOption: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
    }),
};

Select.defaultProps = {
    allOption: {
        label: 'Select all',
        value: '*',
    },
};

export default Select;
